// components/monthlyExpensesInRetirementForm.js
import React, { useState, useEffect } from 'react';
import { 
  CardContent, 
  Typography, 
  TextField,
  InputAdornment,
  Box,
  Stack,
  Button,
  Dialog,
  DialogContent,
  DialogActions,
} from '@mui/material';
import InfoIcon from '@mui/icons-material/Info';
import { useAppContext } from '../context/AppContext';
import CONFIG from '../utils/config';
import { formatInWords } from '../utils/formatInWords';


function ExpensesInRetirementForm() {
  const current_year = new Date().getFullYear();
  const [infoDialogOpen, setInfoDialogOpen] = useState(false);
  const {state, actions} = useAppContext();
  const formatCorpus = (amount) => {
    if (amount >= 10000000) {
      return (amount / 10000000).toFixed(2) + " Cr";
    } else if (amount >= 100000) {
      return (amount / 100000).toFixed(2) + " Lakhs";
    }
    return amount.toLocaleString("en-IN", {
      // style: "currency",
      currency: "INR",
      maximumFractionDigits: 0,
    });
  };
  const [value, setValue] = useState({
    monthlyExpensesInRetirement: state.monthlyExpensesInRetirement || '',
     corpusRequired: state.corpusRequired || ''
  })

  useEffect(() => {
    const calculateCorpus = () => {
      const monthlyInflationRate = Math.pow(1 + CONFIG.DEFAULT_INFLATION_RATE, 1 / 12) - 1;
      const postRetirementReturn = CONFIG.DEFAULT_POST_RETIREMENT_RETURN[state.riskProfile] ?? CONFIG.DEFAULT_POST_RETIREMENT_RETURN["Conservative"];
      const monthlyPostRetirementDiscountRate = Math.pow(1 + postRetirementReturn, 1 / 12) - 1;
      const yearlyExpensesInRetirement = state.monthlyExpensesInRetirement*12;
      const yearsInRetirement = CONFIG.DEFAULT_LIFE_EXPECTANCY - state.retirementAge
      const retirementExpenses_FV = yearlyExpensesInRetirement * Math.pow(1 + CONFIG.DEFAULT_INFLATION_RATE, state.yearsForRetirement)
      const corpusRequired = (retirementExpenses_FV/12) * (1 - Math.pow((1+monthlyInflationRate)/ (1 + monthlyPostRetirementDiscountRate), yearsInRetirement * 12)) / 
      (monthlyPostRetirementDiscountRate - monthlyInflationRate)
      actions.updateFormData('corpusRequired', Math.round(corpusRequired));
    };
  
    if (state.monthlyExpensesInRetirement > 0) {
      calculateCorpus();
    }
  }, [state.monthlyExpensesInRetirement, state.riskProfile]); // runs when component loads or monthlyExpensesInRetirement changes
  

  const handleChange = (e) => {
    let value = parseInt(e.target.value.replace(/,/g, ''), 10);
    if (isNaN(value)) value = 0;
    // onChange('monthlyExpensesInRetirement', value);
    setValue(prev => ({ ...prev, monthlyExpensesInRetirement: value }));
    actions.updateFormData('monthlyExpensesInRetirement', value)
  };
  const handleInfoDialogOpen = () => {
    setInfoDialogOpen(true);
};

const handleInfoDialogClose = () => {
    setInfoDialogOpen(false);
};

  // Format number with commas
  const formatNumber = (num) => {
    return new Intl.NumberFormat('en-IN').format(num);
  };

  return (
    <Box>
      <CardContent>
        <Typography variant="h6" component="h2" gutterBottom>
          In today's terms, how much would you spend per month to retire comfortably?
        </Typography>
        {/* <Typography variant="body2" color="textSecondary" paragraph>
          This helps us calculate how much you'll need for retirement.
        </Typography> */}
        
        <Box sx={{ mt: 4 }}>
        <TextField
            label="Monthly Expenses For Retirement"
            value={value.monthlyExpensesInRetirement ? formatNumber(value.monthlyExpensesInRetirement) : ""}
            onChange={handleChange}
            fullWidth
            type="tel"
            inputMode="numeric"
            InputProps={{
              startAdornment: <InputAdornment position="start">₹</InputAdornment>,
            }}
        />
        {value.monthlyExpensesInRetirement >= 1000 && (
        <Typography variant="body2" sx={{ mt: 1, color: 'text.secondary' }}>
          {formatInWords(value.monthlyExpensesInRetirement)}
        </Typography>)}
        </Box>
        <Stack spacing={2} sx={{mt:4}}>

          { state.corpusRequired ? (
            <>
            <Typography variant="body1" fontWeight="bold">
            You will need <span style={{ color: "#1976d2" }}>₹{formatCorpus(state.corpusRequired)}</span> in <span style={{ color: "#1976d2" }}>{current_year + Number(state.yearsForRetirement === -1 ? 0 : state.yearsForRetirement)}</span> to secure your retirement.🏌️ 
            <Button
            variant="text"
            color="primary"
            startIcon={<InfoIcon />}
            // endIcon={<KeyboardArrowDownIcon />}
            onClick={handleInfoDialogOpen}
            // sx={{ mb: 3, textTransform: 'none', fontSize: '0.875rem' }}
        >
          </Button>
          </Typography>
          <Typography variant="body1">
            Now let’s plan your other financial goals.
          </Typography></>) : (<></>) }

          {/* <Typography variant="caption" fontStyle="italic">
            Start investing early. Future You will say thanks! 🙌
          </Typography> */}
        </Stack>
        <Dialog
              open={infoDialogOpen}
              onClose={handleInfoDialogClose}
              aria-labelledby="info-dialog-title"
              maxWidth="sm"
              fullWidth
            >
              <DialogContent>
          <Typography variant="body2" color="textSecondary">
          Assumptions:<br></br>
          Life expectancy: {CONFIG.DEFAULT_LIFE_EXPECTANCY} Years<br></br>
          Your expenses will inflate at {CONFIG.DEFAULT_INFLATION_RATE_STRING} per annum.<br></br>
          </Typography> 
            </DialogContent>
            <DialogActions>
              <Button onClick={handleInfoDialogClose} variant="contained">
                  Got it
              </Button>
            </DialogActions>
            </Dialog>
      </CardContent>
      </Box>
  );
}

export default ExpensesInRetirementForm;
